import { SmartTable } from '../../../../../components/smart-table/smart-table.model';
import { isAzure } from './directory.functions';

export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        this.st = {};
        this.domains.forEach((domain) => this.st[domain.domainName] = new SmartTable());
        this.isAzure = isAzure(this.directory);
    }

    reload() {
        this.isReloading = true;
        this.$state.reload(this.$state.current)
            .finally(() => this.isReloading = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/directory.controller.js